import React from 'react'
import { TagIcon } from './components/tag-icon'
import { TagLabel } from './components/tag-label'
import * as Comp from './tag.styles'
import type { TTagProps } from './types'

const TagRoot = ({ children, testID, variant = 'similar' }: TTagProps) => {
  const renderInternalLabel = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === TagLabel) {
      return React.cloneElement(child as React.ReactElement<TTagProps>, {
        variant,
      })
    }
  })

  const renderInternalIcon = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === TagIcon) {
      return React.cloneElement(child as React.ReactElement<TTagProps>, {
        variant,
      })
    }
  })

  const componentProperties = {
    variant: variant,
    hasIcon: !!renderInternalIcon?.length,
  }

  return (
    <Comp.Root testID={testID} {...componentProperties}>
      <Comp.Content {...componentProperties}>
        {renderInternalIcon}
        {renderInternalLabel}
      </Comp.Content>
    </Comp.Root>
  )
}

export const Tag = {
  Root: TagRoot,
  Label: TagLabel,
  Icon: TagIcon,
}

export type { TTagProps }
